<div class="hproduct-list-page">
    <div class="list-header">
        <h2 class="text-center">Produits immobiliers</h2>
    </div>
       <div class="mb-3">
            <button class="btn btn-primary" type="button" (click)="onAddProduct()">Ajouter
                un produit</button>
        </div>
            
    @if (products&&products.content&&products.content.length == 0) {
        <div class="empty-state">
            <p>Aucun produit trouvé. Utilisez le formulaire pour ajouter un premier produit.</p>
        </div>
    }

    @if (products&&products.content&&products.content.length>0) {
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead class="table-dark">
                    <tr>
                        <th>Nom</th>
                        <th>Type</th>
                        <th>Zone</th>
                        <th>Prix</th>
                        <th>Superficie</th>
                    </tr>
                </thead>
                <tbody>
                   @for( product of products.content| paginate: pageConfig;track $index) {
                        <tr>
                            <td><span>{{ product.name }}</span></td>
                            <td>{{ product.type }}</td>
                            <td>{{ product.zone }}</td>
                            <td><span>{{ product.price }} CFA</span></td>
                            <td>{{ product.superficie }} m²</td>
                        </tr>
                   }
                </tbody>
            </table>
        </div>

        <!-- Pagination Controls -->
        <div class="pagination-container d-flex justify-content-center mt-4">
            <pagination-controls
                (pageChange)="onPageChange($event)"
                [responsive]="true"
                [maxSize]="5"
                [directionLinks]="true"
                [autoHide]="false"
                previousLabel="Précédent"
                nextLabel="Suivant"
                screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page"
                screenReaderCurrentLabel="Vous êtes sur la page">
            </pagination-controls>
        </div>

       
    }
</div>
